import React from 'react';
import { Button } from 'react-toolbox/lib/button';
import { FontIcon } from 'react-toolbox/lib/font_icon';
import styles from './StepMenuItem.css';
import buttonTheme from './StepMenuItemButtonTheme.css';

const StepMenuItem = ({
  active,
  completed,
  error,
  label,
  number,
  onClick,
  ...props
}) =>
  <li className={styles.container} role="menuitem" {...props}>
    <Button
      onClick={onClick}
      theme={buttonTheme}
      aria-label={`(${number}) ${label}`}
      ripple={false}
      flat
    >
      {completed
        ? <span className={styles.avatarCompleted}>
            <FontIcon value="check" />
          </span>
        : <span className={error ? styles.avatarError : styles.avatar}>
            {number}
          </span>}
      <span
        className={
          active
            ? error ? styles.labelActiveError : styles.labelActive
            : error ? styles.labelError : styles.label
        }
      >
        {label}
      </span>
    </Button>
  </li>;

export default StepMenuItem;



// WEBPACK FOOTER //
// ./src/general-components/StepMenuItem.js